import { render, staticRenderFns } from "./ReferralPage.vue?vue&type=template&id=00f73f87&scoped=true"
import script from "./ReferralPage.vue?vue&type=script&lang=js"
export * from "./ReferralPage.vue?vue&type=script&lang=js"
import style0 from "./ReferralPage.vue?vue&type=style&index=0&id=00f73f87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f73f87",
  null
  
)

export default component.exports